export const HIDE_BULK_CATEGORY_ADDER =
	'state.actions.hide-bulk-category-adder.HIDE_BULK_CATEGORY_ADDER' as const;

export type HideBulkCategoryAdder = {
	articleId: string;
};

export type HideBulkCategoryAdderAction = {
	type: typeof HIDE_BULK_CATEGORY_ADDER;
	payload: HideBulkCategoryAdder;
};

export const hideBulkCategoryAdder = (
	payload: HideBulkCategoryAdder,
): HideBulkCategoryAdderAction => ({
	payload,
	type: HIDE_BULK_CATEGORY_ADDER,
});
